import {
  DOWNLOAD_ACTIVITY_FILE_FAILURE,
  DOWNLOAD_ACTIVITY_FILE_REQUEST,
  DOWNLOAD_ACTIVITY_FILE_SUCCESS,
  FETCH_ACTIVITY_LIST_FAILURE,
  FETCH_ACTIVITY_LIST_REQUEST,
  FETCH_ACTIVITY_LIST_SUCCESS,
} from "./actionTypes";

export const fetchActivityListRequest = (url: string, payload: any) => ({
  type: FETCH_ACTIVITY_LIST_REQUEST,
  url,
  payload,
});

export const fetchActivityListSuccess = (payload: any) => ({
  type: FETCH_ACTIVITY_LIST_SUCCESS,
  payload: payload,
});

export const fetchActivityListFailure = (payload: any) => ({
  type: FETCH_ACTIVITY_LIST_FAILURE,
  payload: payload,
});

export const downloadActivityFileRequest = (url: any, payload: any, callback: unknown) => ({
  type: DOWNLOAD_ACTIVITY_FILE_REQUEST,
  url,
  payload,
  callback
});

export const downloadActivityFileSuccess = (payload: any) => ({
  type: DOWNLOAD_ACTIVITY_FILE_SUCCESS,
  payload: payload,
});

export const downloadActivityFileFailure = (payload: any) => ({
  type: DOWNLOAD_ACTIVITY_FILE_FAILURE,
  payload: payload,
});
